module.exports = __webpack_public_path__ + "static/media/collapse.9ac3e5fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/CompanyPublic/img/collapse.svg
// module id = 6961
// module chunks = 0